module.exports = __webpack_public_path__ + "src/assets/textures/env/street_road/road_02_512_bake.png";